module.exports = __webpack_public_path__ + "static/media/plenum.a7a3816d.png";